<template>
  <v-menu v-model="mostrar" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </template>
    <v-card
      width="450px">
      <v-card-title>Filtros</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <custom-select
            v-model="filtros.tipos"
            label="Tipo"
            item-value="id"
            item-text="descripcion"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="tiposDeObra">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.programas"
            label="Programa"
            item-value="id"
            item-text="nombre"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="programas">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
// import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'FiltrosPlaneacion',
  components: {
    // CustomAutoComplete,
    CustomSelect,
  },
  props: {
    obras: {
      type: Array,
      required: false,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
      tiposLicitacion: [
        { id: 1, texto: 'LICITACIÓN PÚBLICA' },
        { id: 2, texto: 'LICITACIÓN RESTINGIDA POR INVITACIÓN' },
      ],
      tiposCaracter: [
        { id: 1, texto: 'NACIONAL' },
      ],
      tiposNormatividad: [
        { id: 1, texto: 'FEDERAL' },
        { id: 2, texto: 'ESTATAL' },
      ],
    };
  },
  methods: {
  },
  computed: {
    tiposDeObra() {
      const tiposDeObra = this.obras
        .map((obra) => obra.tipo);
      return this.$removerDumplicadosArrayObj(tiposDeObra, 'id')
        .sort((a, b) => (`${a.descripcion}`).localeCompare(b.descripcion));
    },
    programas() {
      const programas = this.obras
        .map((obra) => obra.programa);
      return this.$removerDumplicadosArrayObj(programas, 'id')
        .sort((a, b) => (`${a.nombre}`).localeCompare(b.nombre));
    },
  },
};
</script>

<style lang="scss">
</style>
